/**
 * @file members.js
 * @location src/data/members.js
 * @role 멤버 마스터 시드 데이터
 *
 * INIT_MEMBERS 멤버 시드 배열 (id, name, email?, mainCases?, isManager?, pending?) — razor ⑳ 직급 폐기
 *   - 런타임 실데이터는 useAppStore 의 S.members (localStorage 영속화)
 *   - INIT_MEMBERS 는 최초 부트스트랩 / RESET_DATA 시드용
 *   - 아이디 규칙: 'm' + 숫자 (m1~m11)
 *   - 상태 커버리지(검증용): ★매니저(m1) · 멤버(m2~m9) ·
 *     초대중/유효(m10) · 초대중/만료됨(m11). 멤버탭 전 상태가 시드만으로 재현됨.
 */

// 초대 시드 invitedAt — 모듈 평가 시점 기준 상대일. inviteCode.js 7일 TTL 대비 유효/만료 재현용.
const agoISO = (days) => new Date(Date.now() - days * 86400000).toISOString();

// razor ⑳·㉒: 직급 폐기 + 단일 매니저 수렴 — 구분은 isManager(매니저/팀원) 하나, 매니저는 오너 1명(m1).
export const INIT_MEMBERS = [
  {
    id: 'm1', name: '표한결',
    email: 'pyo@workdo.kr',
    mainCases: ['Q2 예산 수립', '거래처 A 정기'],
    isManager: true,
  },
  {
    id: 'm2', name: '옥다온',
    email: 'ok@workdo.kr',
    mainCases: ['신규 영업 캠페인'],
  },
  {
    id: 'm3', name: '마윤슬',
    email: 'ma@workdo.kr',
    mainCases: ['거래처 B 안건'],
  },
  {
    id: 'm4', name: '변새봄',
    email: 'byeon@workdo.kr',
    mainCases: [],
  },
  {
    id: 'm5', name: '선우라온',
    email: 'sunwoo@workdo.kr',
    mainCases: ['기간 시스템 개편', '채용 면접'],
  },
  {
    id: 'm6', name: '천보름',
    email: 'cheon@workdo.kr',
    mainCases: ['인증 모듈 개선'],
  },
  {
    id: 'm7', name: '빈도하',
    email: 'bin@workdo.kr',
    mainCases: ['API 성능 조사'],
  },
  {
    id: 'm8', name: '명가온',
    email: 'myeong@workdo.kr',
    mainCases: ['인사 평가 제도 개선'],
  },
  {
    id: 'm9', name: '위서림',
    email: 'wi@workdo.kr',
    mainCases: [],
  },
  // ── 초대중(pending) 좌석 — 본인 미참여. 이름/이메일/담당영역는 참여 시 본인이 입력 (razor ⑪) ──
  // 검증용: 「초대중」 배지 + INV 코드 + 남은 일수 노출 (유효 코드)
  {
    id: 'm10', name: '',
    email: '', mainCases: [],
    pending: { code: 'INV-K7Q3', invitedAt: agoISO(1) },   // 6일 남음 — 유효
  },
  // 검증용: 만료됨(만료) 초대 — 「만료됨」 + 재발급 강조 노출
  {
    id: 'm11', name: '',
    email: '', mainCases: [],
    pending: { code: 'INV-P9X2', invitedAt: agoISO(10) },  // 7일 TTL 초과 → 만료됨
  },
];
